export default {
    // пример
    // intro: {
    //     text: 'Welcome to the <span class="highlight">awesome</span> TooDoo App'
    // },
    // todos: {
    //     placeholder: 'Добавить что непонятное',
    //     all: 'all',
    //     active: 'active',
    //     completed: 'completed',
    //     indicator: '{count} item left ::: {count} items left'
    // },
    // about: {
    //     name: 'About',
    // },

    /*
    Страницы и компоненты
     */

    reading_room: {
        readingroom: 'Читальный зал',
    },
    'Выберите нужные форматы для скачивания:': 'Выберите нужные форматы для скачивания:',
    download_limit_exceeded: 'Превышен лимит скачиваний, для скачивания моделей пожалуйста, подтвердите, что вы не робот',
    'companyCount': 'Ещё {count} компания ::: Ещё {count} компании ::: Ещё {count} компаний'
}